import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-hamburger-icon',
  templateUrl: 'hamburger.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HamburgerIcon { }
